import React from 'react';
import propTypes from 'prop-types';
import { Routes, Route, useLocation } from 'react-router-dom';
import { FIListPage } from './FIListPage';
import { FIEditPageWrapper } from './FIEditPageWrapper';

export function FIPage({ isExpanded }) {
  const location = useLocation();
  return (
    <Routes location={location}>
      <Route
        path="/"
        exact
        element={<FIListPage isExpanded={isExpanded} />}
      />
      <Route
        path="add"
        element={<FIEditPageWrapper isExpanded={isExpanded} />}
      />
      <Route
        path="edit/:id"
        element={<FIEditPageWrapper isExpanded={isExpanded} />}
      />
    </Routes>
  );
}

FIPage.propTypes = {
  isExpanded: propTypes.bool.isRequired,
};
